import { FC } from 'react'
import { SvgProps } from './svgProps'

const LoaderIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={width || 18}
    height={height || 18}
    viewBox="0 0 18 18"
  >
    <rect x="0" y="0" width="4" height="18" fill={color || '#fff'}>
      <animate
        attributeName="opacity"
        attributeType="XML"
        values="1; .2; 1"
        begin="0s"
        dur="0.6s"
        repeatCount="indefinite"
      ></animate>
    </rect>
    <rect x="7" y="0" width="4" height="18" fill={color || '#fff'}>
      <animate
        attributeName="opacity"
        attributeType="XML"
        values="1; .2; 1"
        begin="0.2s"
        dur="0.6s"
        repeatCount="indefinite"
      ></animate>
    </rect>
    <rect x="14" y="0" width="4" height="18" fill={color || '#fff'}>
      <animate
        attributeName="opacity"
        attributeType="XML"
        values="1; .2; 1"
        begin="0.4s"
        dur="0.6s"
        repeatCount="indefinite"
      ></animate>
    </rect>
  </svg>
)

export default LoaderIcon
